export default {
    1: "Stone Wall",
    2: "Dirt Wall (natural)",
    3: "Ebonstone Wall (natural)",
    4: "Wood Wall",
    5: "Gray Brick Wall",
    6: "Red Brick Wall",
    7: "Blue Brick Wall (natural)",
    8: "Green Brick Wall (natural)",
    9: "Pink Brick Wall (natural)",
    10: "Gold Brick Wall",
    11: "Silver Brick Wall",
    12: "Copper Brick Wall",
    13: "Hellstone Brick Wall (natural)",
    14: "Obsidian Brick Wall (natural)",
    15: "Mud Wall (natural)",
    16: "Dirt Wall",
    17: "Blue Brick Wall",
    18: "Green Brick Wall",
    19: "Pink Brick Wall",
    20: "Obsidian Brick Wall",
    21: "Glass Wall",
    22: "Pearlstone Brick Wall",
    23: "Iridescent Brick Wall",
    24: "Mudstone Brick Wall",
    25: "Cobalt Brick Wall",
    26: "Mythril Brick Wall",
    27: "Planked Wall",
    28: "Pearlstone Wall (natural)",
    29: "Candy Cane Wall",
    30: "Green Candy Cane Wall",
    31: "Snow Brick Wall",
    32: "Adamantite Beam Wall",
    33: "Demonite Brick Wall",
    34: "Sandstone Brick Wall",
    35: "Ebonstone Brick Wall",
    36: "Red Stucco Wall",
    37: "Yellow Stucco Wall",
    38: "Green Stucco Wall",
    39: "Gray Stucco Wall",
    40: "Snow Wall (natural)",
    41: "Ebonwood Wall",
    42: "Rich Mahogany Wall",
    43: "Pearlwood Wall",
    44: "Rainbow Brick Wall",
    45: "Tin Brick Wall",
    46: "Tungsten Brick Wall",
    47: "Platinum Brick Wall",
    48: "Amethyst Stone Wall (natural)",
    49: "Topaz Stone Wall (natural)",
    50: "Sapphire Stone Wall (natural)",
    51: "Emerald Stone Wall (natural)",
    52: "Ruby Stone Wall (natural)",
    53: "Diamond Stone Wall (natural)",
    54: "Green Mossy Wall (natural)",
    55: "Brown Mossy Wall (natural)",
    56: "Red Mossy Wall (natural)",
    57: "Blue Mossy Wall (natural)",
    58: "Purple Mossy Wall (natural)",
    59: "Rocky Dirt Wall (natural)",
    60: "Living Leaf Wall (natural)",
    61: "Iron Cave Wall (natural)",
    62: "Spider Wall (natural)",
    63: "Grass Wall (natural)",
    64: "Jungle Wall (natural)",
    65: "Flower Wall (natural)",
    66: "Grass Wall",
    67: "Jungle Wall",
    68: "Flower Wall",
    69: "Corrupt Grass Wall (natural)",
    70: "Hallowed Grass Wall (natural)",
    71: "Ice Wall (natural)",
    72: "Cactus Wall",
    73: "Cloud Wall",
    74: "Mushroom Wall",
    75: "Bone Block Wall",
    76: "Slime Block Wall",
    77: "Flesh Block Wall",
    78: "Living Wood Wall",
    79: "Obsidian Back Wall (natural)",
    80: "Mushroom Wall (natural)",
    81: "Crimson Grass Wall (natural)",
    82: "Disc Wall",
    83: "Crimstone Wall (natural)",
    84: "Ice Brick Wall",
    85: "Shadewood Wall",
    86: "Hive Wall (natural)",
    87: "Lihzahrd Brick Wall (natural)",
    88: "Purple Stained Glass",
    89: "Yellow Stained Glass",
    90: "Blue Stained Glass",
    91: "Green Stained Glass",
    92: "Red Stained Glass",
    93: "Multicolored Stained Glass",
    94: "Blue Slab Wall (natural)",
    95: "Blue Tiled Wall (natural)",
    96: "Pink Slab Wall (natural)",
    97: "Pink Tiled Wall (natural)",
    98: "Green Slab Wall (natural)",
    99: "Green Tiled Wall (natural)",
    100: "Blue Slab Wall",
    101: "Blue Tiled Wall",
    102: "Pink Slab Wall",
    103: "Pink Tiled Wall",
    104: "Green Slab Wall",
    105: "Green Tiled Wall",
    106: "Wooden Fence",
    107: "Lead Fence",
    108: "Hive Wall",
    109: "Palladium Column Wall",
    110: "Bubblegum Block Wall",
    111: "Titanstone Block Wall",
    112: "Lihzahrd Brick Wall",
    113: "Pumpkin Wall",
    114: "Hay Wall",
    115: "Spooky Wood Wall",
    116: "Christmas Tree Wallpaper",
    117: "Ornament Wallpaper",
    118: "Candy Cane Wallpaper",
    119: "Festive Wallpaper",
    120: "Stars Wallpaper",
    121: "Squiggles Wallpaper",
    122: "Snowflake Wallpaper",
    123: "Krampus Horn Wallpaper",
    124: "Bluegreen Wallpaper",
    125: "Grinch Finger Wallpaper",
    126: "Fancy Grey Wallpaper",
    127: "Ice Floe Wallpaper",
    128: "Music Wallpaper",
    129: "Purple Rain Wallpaper",
    130: "Rainbow Wallpaper",
    131: "Sparkle Stone Wallpaper",
    132: "Starlit Heaven Wallpaper",
    133: "Bubble Wallpaper",
    134: "Copper Pipe Wallpaper",
    135: "Ducky Wallpaper",
    136: "Waterfall Wall",
    137: "Lavafall Wall",
    138: "Ebonwood Fence",
    139: "Rich Mahogany Fence",
    140: "Pearlwood Fence",
    141: "Shadewood Fence",
    142: "White Dynasty Wall",
    143: "Blue Dynasty Wall",
    144: "Mystic Rune Wallpaper",
    145: "Iron Fence",
    146: "Copper Plating Wall",
    147: "Stone Slab Wall",
    148: "Sail",
    149: "Boreal Wood Wall",
    150: "Boreal Wood Fence",
    151: "Palm Wood Wall",
    152: "Palm Wood Fence",
    153: "Amber Gemspark Wall",
    154: "Amethyst Gemspark Wall",
    155: "Diamond Gemspark Wall",
    156: "Emerald Gemspark Wall",
    157: "Offline Amber Gemspark Wall",
    158: "Offline Amethyst Gemspark Wall",
    159: "Offline Diamond Gemspark Wall",
    160: "Offline Emerald Gemspark Wall",
    161: "Offline Ruby Gemspark Wall",
    162: "Offline Sapphire Gemspark Wall",
    163: "Offline Topaz Gemspark Wall",
    164: "Ruby Gemspark Wall",
    165: "Sapphire Gemspark Wall",
    166: "Topaz Gemspark Wall",
    167: "Tin Plating Wall",
    168: "Confetti Wall",
    169: "Midnight Confetti Wall",
    170: "Cave Dirt Wall (natural)",
    171: "Rough Dirt Wall (natural)",
    172: "Honeyfall Wall",
    173: "Chlorophyte Brick Wall",
    174: "Crimtane Brick Wall",
    175: "Shroomite Plating Wall",
    176: "Martian Conduit Wall",
    177: "Hellstone Brick Wall",
    178: "Marble Wall (natural)",
    179: "Smooth Marble Wall",
    180: "Granite Wall (natural)",
    181: "Smooth Granite Wall",
    182: "Meteorite Brick Wall",
    183: "Marble Wall",
    184: "Granite Wall",
    185: "Craggy Stone Wall (natural)",
    186: "Crystal Block Wall",
    187: "Sandstone Wall (natural)",
    188: "Corrupt Growth Wall (natural)",
    189: "Corrupt Mass Wall (natural)",
    190: "Corrupt Pustule Wall (natural)",
    191: "Corrupt Tendril Wall (natural)",
    192: "Crimson Crust Wall (natural)",
    193: "Crimson Scab Wall (natural)",
    194: "Crimson Teeth Wall (natural)",
    195: "Crimson Blister Wall (natural)",
    196: "Layered Dirt Wall (natural)",
    197: "Crumbling Dirt Wall (natural)",
    198: "Cracked Dirt Wall (natural)",
    199: "Wavy Dirt Wall (natural)",
    200: "Hallowed Prism Wall (natural)",
    201: "Hallowed Cavern Wall (natural)",
    202: "Hallowed Shard Wall (natural)",
    203: "Hallowed Crystalline Wall (natural)",
    204: "Lichen Stone Wall (natural)",
    205: "Leafy Jungle Wall (natural)",
    206: "Ivy Stone Wall (natural)",
    207: "Jungle Vine wall (natural)",
    208: "Ember Wall (natural)",
    209: "Cinder Wall (natural)",
    210: "Magma Wall (natural)",
    211: "Smouldering Stone Wall (natural)",
    212: "Worn Stone Wall (natural)",
    213: "Mottled Stone Wall (natural)",
    214: "Mottled Stone Wall (natural)",
    215: "Fractured Stone Wall (natural)",
    216: "Hardened Sand Wall (natural)",
    217: "Hardened Ebonsand Wall (natural)",
    218: "Hardened Crimsand Wall (natural)",
    219: "Hardened Pearlsand Wall (natural)",
    220: "Ebonsandstone Wall (natural)",
    221: "Crimsandstone Wall (natural)",
    222: "Pearlsandstone Wall (natural)",
    223: "Desert Fossil Wall (natural)",
    224: "Luminite Brick Wall",
    225: "Cog Wall",
    226: "Sandfall Wall",
    227: "Snowfall Wall",
    228: "Silly Pink Balloon Wall",
    229: "Silly Purple Balloon Wall",
    230: "Silly Green Balloon Wall",
    231: "Iron Brick Wall",
    232: "Lead Brick Wall",
    233: "Lesion Block Wall",
    234: "Crimstone Brick Wall",
    235: "Smooth Sandstone Wall",
    236: "Spider Nest Wall",
    237: "Solar Brick Wall",
    238: "Vortex Brick Wall",
    239: "Nebula Brick Wall",
    240: "Stardust Brick Wall",
    241: "Orange Stained Glass",
    242: "Gold Starry Wall",
    243: "Blue Starry Wall",
    244: "Living Wood Wall (natural)",
    245: "Wrought Iron Fence",
    246: "Ebonstone Wall",
    247: "Mud Wall",
    248: "Pearlstone Wall",
    249: "Snow Wall",
    250: "Amethyst Stone Wall",
    251: "Topaz Stone Wall",
    252: "Sapphire Stone Wall",
    253: "Emerald Stone Wall",
    254: "Ruby Stone Wall",
    255: "Diamond Stone Wall",
    256: "Green Mossy Wall",
    257: "Brown Mossy Wall",
    258: "Red Mossy Wall",
    259: "Blue Mossy Wall",
    260: "Purple Mossy Wall",
    261: "Rocky Dirt Wall",
    262: "Old Stone Wall",
    263: "Spider Wall",
    264: "Corrupt Grass Wall",
    265: "Hallowed Grass Wall",
    266: "Ice Wall",
    267: "Obsidian Wall",
    268: "Crimson Grass Wall",
    269: "Crimstone Wall",
    270: "Cave Dirt Wall",
    271: "Rough Dirt Wall",
    274: "Craggy Stone Wall",
    275: "Sandstone Wall",
    276: "Corrupt Growth Wall",
    277: "Corrupt Mass Wall",
    278: "Corrupt Pustule Wall",
    279: "Corrupt Tendril Wall",
    280: "Crimson Crust Wall",
    281: "Crimson Scab Wall",
    282: "Crimson Teeth Wall",
    283: "Crimson Blister Wall",
    284: "Layered Dirt Wall",
    285: "Crumbling Dirt Wall",
    286: "Cracked Dirt Wall",
    287: "Wavy Dirt Wall",
    288: "Hallowed Prism Wall",
    289: "Hallowed Cavern Wall",
    290: "Hallowed Shard Wall",
    291: "Hallowed Crystalline Wall",
    292: "Lichen Stone Wall",
    293: "Leafy Jungle Wall",
    294: "Ivy Stone Wall",
    295: "Jungle Vine Wall",
    296: "Ember Wall",
    297: "Cinder Wall",
    298: "Magma Wall",
    299: "Smouldering Stone Wall",
    300: "Worn Stone Wall",
    301: "Stalactite Stone Wall",
    302: "Mottled Stone Wall",
    303: "Fractured Stone Wall",
    304: "Hardened Sand Wall",
    305: "Hardened Ebonsand Wall",
    306: "Hardened Crimsand Wall",
    307: "Hardened Pearlsand Wall",
    308: "Ebonsandstone Wall",
    309: "Crimsandstone Wall",
    310: "Pearlsandstone Wall",
    311: "Desert Fossil Wall",
    312: "Bamboo Wall",
    313: "Large Bamboo Wall",
    314: "Amber Stone Wall",
    315: "Bamboo Fence"
}